const getAvgPeriodSelectedOption = function (cookieValue, avgPeriodOptions) {
	if (!cookieValue) {
		return avgPeriodOptions[0];
	}
	var found = false;
	avgPeriodOptions.forEach(function (item) {
		if (item === cookieValue) {
			found = true;
		}
	});
	if (found) {
		return cookieValue;
	}
	return avgPeriodOptions[0];

};

const getDisplayName = function(item) {
	let name = item.text ? item.text : item.name;
	if (item.itemType === itemTypeManager.MonitoringLocation) {
		let instrumentsString =
			item.instrumentCount > 1
				? resourcesObject.Admin_Instruments
				: resourcesObject.Common_Instrument;
		return `${
			name
		} (${item.instrumentCount.toString()} ${instrumentsString})`;
	} else if (itemTypeManager.isInstrument(item.itemType)) {
		// Crimes
		let monitorNameOrSerial = item.monitorName ? item.monitorName : item.serial;
		if (item.monitoringLocation) {
			monitorNameOrSerial = getAttachedInstrDisplay(
				monitorNameOrSerial,
				item.monitoringLocation,
				resourcesObject.Admin_AttachedTo
			);
		}
		var subText = item.serial;
		subText += " &#8226; " + item.organisation;
		return `<div><label id="${item.id.replace(/ /g, "")}${
			item.leaseID ? "-" + item.leaseID : ""
		}">${monitorNameOrSerial}</label><label class="sub">${subText}</label></div>`;
	}

	return name;
};

const getAttachedInstrDisplay = function(
	serial,
	monitoringLocation,
	resourceAttachTo
) {
	return (
		serial +
		" <span class='gray'>| <i>" +
		resourceAttachTo +
		" " +
		monitoringLocation +
		"</i></span>"
	);
};

// converts '1 hour' 'five minutes' etc to the number in minutes
const convertSettingsPeriodToMinutes = function (inputString) {
	if (inputString === resourcesObject.Common_Daily) {
		return 60 * 24;	
	}
	
	var timeString = inputString.split(" ")[1].toLowerCase();

	var number = 60; // default to hourly
	if (resourcesObject.Common_XMinutes.includes(timeString)) {
		number = inputString.split(" ")[0];
	}
	else if (resourcesObject.Common_OneHour.includes(timeString)) {
		number = inputString.split(" ")[0] * 60;
	}
	else if (resourcesObject.Common_XHours.includes(timeString)) {
		number = inputString.split(" ")[0] * 60;
	}
	return parseInt(number);
};

window.getAvgPeriodSelectedOption = getAvgPeriodSelectedOption;
window.getDisplayName = getDisplayName;
window.getAttachedInstrDisplay = getAttachedInstrDisplay;
export { getAvgPeriodSelectedOption, getDisplayName, convertSettingsPeriodToMinutes };
